import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { KeyValue } from "../models/common";
import { Result } from "../models/common/resultResponse";
import { IBrandApi } from "./base";
import { PartBrandDomainRequest } from "../models/request";
import { isNullUndefined } from "../services/utils";

const baseRoute: string = "PartBrand";

export class BrandApi extends IBrandApi {
	getDomain(request: PartBrandDomainRequest | null = null): Promise<AxiosResponse<Result<KeyValue[]>>> {
		const requestFormatted = isNullUndefined(request) ? {} : request;
		return api.get(`${baseRoute}/domain`, { params: requestFormatted });
	}
}
